import { z } from 'zod';
import type { BaseEntity } from './common';
import type { ProfitCenterIntegration } from './profitCenterIntegration';

/**
 * Interfaccia per ProfitCenter
 * Utilizzabile sia per response (GET) che per payload (POST/PUT)
 */
export interface ProfitCenter extends BaseEntity {
	/** Codice identificativo del centro di profitto (max 50 caratteri) */
	code: string;
	/** Nome del centro di profitto */
	name: string;
	/** Indica se è disabilitato */
	isDisabled?: boolean | null;
	/** Lista delle integrazioni del centro di profitto (navigation property) */
	integrations?: ProfitCenterIntegration[];
}

/**
 * Tipo per il risultato dell'autocomplete ProfitCenter
 * Corrisponde ai campi selezionati nella query OData: id, code, name
 */
export type ProfitCenterAutocompleteResult = Pick<ProfitCenter, 'id' | 'code' | 'name'>;

/**
 * Schema Zod per la validazione runtime dei ProfitCenter
 */
export const ProfitCenterSchema = z.object({
	id: z.number(),
	code: z.string(),
	name: z.string(),
	isDisabled: z.boolean().nullish(), // Può essere boolean, null o undefined
	// Campi audit da BaseEntity
	createdAt: z.string().optional(), // Può non essere sempre presente
	modifiedAt: z.string().optional(),
	createdBy: z.string().optional(), // Può non essere sempre presente
	modifiedBy: z.string().optional(),
	// Navigation property opzionale (non validata in runtime)
	integrations: z.array(z.any()).optional(),
});
